import { PropsWithChildren } from 'react';
import { ThemeProvider } from 'styled-components';

import { WorkspaceTheme, useWorkspaceThemeQuery } from 'generated/graphql';
import { replaceColorsInTheme } from 'packages/kakapo-ui-application/layouts/BareLayout';
import treams, { placeholderTheme } from 'packages/kakapo-ui-kit/themes/treams';
import { useWorkspace } from 'packages/kakapo-ui-services/hooks/useWorkspace';
import GlobalStyle from 'packages/kakapo-ui-kit/components/GlobalStyle';

export const WorkspaceThemeProvider = ({ children }: PropsWithChildren) => {
	const workspace = useWorkspace();

	const { data, loading } = useWorkspaceThemeQuery({
		variables: { id: workspace.id },
	});

	const theme = loading
		? placeholderTheme
		: data
		? replaceColorsInTheme(data.workspace.theme as WorkspaceTheme)
		: treams;

	return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export const BaseThemeProvider = ({ children }: PropsWithChildren) => {
	return (
		<ThemeProvider theme={treams}>
			<GlobalStyle />
			{children}
		</ThemeProvider>
	);
};
